import React from 'react'
import { Box, IconButton, Typography } from '@mui/material'
import DeleteIcon from '@mui/icons-material/Delete'
import ErrorOutlineOutlinedIcon from '@mui/icons-material/ErrorOutlineOutlined'
import CancelIcon from '@mui/icons-material/Cancel'
import {
  BoxStyle,
  CancelIconStyle,
  DeleteIconStyle,
  DeleteIconButtonStyle,
  LoadingIconStyle,
  TextErrorStyle,
  TextLoadingStyle,
  TextStyle,
} from './FileUploadStatusLabel.styles'

interface FileUploadStatusLabelProps {
  file?: string
  loading?: boolean
  hasError?: boolean
  handleDelete?: () => void
}

/**
 * FileUploadStatusLabel
 * @param file
 * @param loading
 * @param hasError
 * @param handleDelete
 * @constructor
 */
export const FileUploadStatusLabel: React.FC<FileUploadStatusLabelProps> = ({
  file,
  loading,
  hasError,
  handleDelete,
}) => {
  return (
    <Box sx={BoxStyle}>
      {loading && (
        <>
          <ErrorOutlineOutlinedIcon sx={LoadingIconStyle} />
          <Typography sx={TextLoadingStyle}>Uploading...</Typography>
        </>
      )}
      {file && !loading && !hasError && (
        <>
          <Typography sx={TextStyle}>{file}</Typography>
          <IconButton onClick={handleDelete} sx={DeleteIconButtonStyle}>
            <DeleteIcon sx={DeleteIconStyle} />
          </IconButton>
        </>
      )}
      {hasError && file && !loading && (
        <>
          <CancelIcon sx={CancelIconStyle} />
          <Typography sx={TextErrorStyle}>Upload {file} was failed</Typography>
        </>
      )}
    </Box>
  )
}
